import React from 'react';
import './TrySpectra.scss';
import { RedirectToSignUp } from '../../../Common/Utils';
import Pattren from '../../../Assets/images/Pattrens/footer.webp';
import { NavLink } from 'react-router-dom';

const TrySpectraAr = () => {

    return (
       <section dir='rtl' className='aug-try-spectra aug-perfec-solution mt-0'>
            <div className='container'>
                <div className='aug-perfec-solution-wrap'>
                    <div className='row'>
                        <div className='col-lg-8 col-md-12 col-12'>
                            <div className='aug-perfec-solution-box'>
                                <h2 className='mb-3'>جرّب Spectra.<br />
                                إنه مجاني لمدة 07 أيام.</h2>
                                <p>لا حاجة إلى بطاقة ائتمان. <br />
                                لا توجد رسوم مقابل التنفيذ والتدريب.</p>
                                <NavLink to="/ar/contact-sales" className="btn btn-outline-white ms-1 ms-sm-3">اطلب عرضًا توضيحيًا</NavLink>
                                <button type="button" className="btn btn-primary" onClick={RedirectToSignUp}>جرّب Spectra</button>
                                
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-12 col-12'>
                            <div className='aug-perfec-solution__img'>
                                <img src={Pattren} alt="pattern" className="img-fluid"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </section>
    );
};

export default TrySpectraAr;